import {
  Button,
  Col,
  Form,
  Row, TimePicker, Input
} from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { RUSH } from "../../config/constants/api";
import { Post } from "../../config/api/post";
import swal from "sweetalert";
import { SmileOutlined } from "@ant-design/icons";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Delete } from "../../config/api";

const RushManagement = () => {
  const token = useSelector((state) => state.user.userToken);
  const [form] = Form.useForm();
  // const [serviceType, setServiceType] = useState("Black");
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate();
  // const [fares, setFares] = useState(null);
  const format = "HH:mm";
  const [ranges, setRanges] = useState(null);
  const getRushHours = () => {
    setLoading(true);
    Get(RUSH.getRushHours, token, {})
      .then((response) => {
        if (response?.status) {
          setRanges(response?.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error Fetching Loads", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getRushHours();
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    // if (values.range[0]?.$H >= values.range[1]?.$H) {
    //   message.error("Invalid Rush Hour Range");
    //   return;
    // }

    const fromTime = values.range[0]?.format("HH:mm");
    const toTime = values.range[1]?.format("HH:mm");

   
    let data = {
      from: fromTime,
      to: toTime,
      rushHourMultiple: values.rushHourMultiple,
    };
    Post(RUSH.addRushHour, data, token)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          form.resetFields();
          getRushHours();
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };

  const handleDelete = (id) => {
    Delete(RUSH.deleteRushHour + id, token)
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          getRushHours();
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        {!loading&&<div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between items-center mx-4 lg:mx-8">
            <div className="flex justify-center items-center">
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Rush Hour Management
              </h3>
            </div>
          </div>

          <Row justify="left" className="mt-8 w-full  customSelect1">
            <Col
              xs={23}
              sm={23}
              md={20}
              lg={20}
              xxl={20}
              className="fareForm px-8 max-xl:px-2"
            >
              <h6>
                {Array.isArray(ranges) &&
                  ranges.map((range, index) => {
                    return (
                      <div
                        key={index}
                        className="showtiming-text flex items-center gap-4"
                      >
                        <p className="font-euclid text-sm max-xl:text-xs text-black font-bold mb-1">
                          Selected Rush Hours
                        </p>
                        <p className="font-tavi lg:text-3x2 text-xl max-sm:text-lg font-normal text-black mb-0">
                          {range?.from}- {range?.to}
                        </p>
                        <p className="font-euclid text-sm max-xl:text-xs text-black font-bold mb-1">
                          Rush Hour Multiple
                        </p>
                        <p className="font-tavi lg:text-3x2 text-xl max-sm:text-lg font-normal text-black mb-0">
                          {range?.rushHourMultiple}
                        </p>
                        <button
                          className="delete-btn"
                          onClick={() => {
                            handleDelete(range._id);
                          }}
                        >
                          <RiDeleteBin6Line />
                        </button>
                      </div>
                    );
                  })}
              </h6>
            </Col>
            <Row justify="left" className="mt-8">
              <Col
                xs={23}
                sm={23}
                md={20}
                lg={24}
                xxl={24}
                className="fareForm"
              >
                <Form
                  form={form}
                  name="editUser"
                  onFinish={onFinish}
                  layout="vertical"
                  className="w-full px-8 max-xl:px-2 customSelect1"
                >
                  <Row justify="" gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="range"
                        label={
                          <p className="font-euclid text-sm text-[#34324B]">
                            Type to Add Rush Hours
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input Rush Hours!",
                          },
                        ]}
                      >
                        <TimePicker.RangePicker
                          prefix={<SmileOutlined />}
                          format={format}
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item
                        name="rushHourMultiple"
                        label={
                          <p className="font-euclid text-sm text-[#34324B]">
                            Type Rush Hour Multiple
                          </p>
                        }
                        rules={[
                          {
                            required: true,
                            message: "Please input Rush Hour Multiple!",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Rush Hour Multiple"
                          className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                          autoComplete={false}
                          type="number"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Button
                    className="uppercase bg-button mx-2 px-2 laptop:px-8 text-black rounded-lg font-bold text-sm max-laptop:text-[8px] max-laptop:py-1 font-euclid"
                    htmlType="submit"
                  >
                    Add
                  </Button>
                </Form>
              </Col>
            </Row>
            {/* </Col> */}
          </Row>
        </div>}
      </Col>
    </Row>
  );
};

export default RushManagement;
